import { Link } from 'react-router-dom';

export default function PTSIntroSection() {
  return (
    <section className="bg-[#F5F1EB] py-20 px-6 lg:px-14">
      <div className="max-w-4xl mx-auto">

        {/* Direct Answer Box */}
        <div className="bg-white border border-[#C9A96E]/35 rounded-2xl px-8 py-7 mb-14">
          <div className="flex items-start gap-4">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#EDE8E0] shrink-0 mt-0.5">
              <i className="ri-lightbulb-line text-[#2D4A3E] text-sm" />
            </div>
            <div>
              <p className="text-[#2D4A3E] font-jost text-xs tracking-[0.2em] uppercase font-semibold mb-2">Direct Answer</p>
              <p className="text-[#1A1A18] font-jost text-sm leading-relaxed mb-3">
                <strong className="font-medium">What are the best places to stay in Highlands, NC?</strong>
              </p>
              <p className="text-[#5C5850] font-jost text-sm leading-relaxed">
                The top overall recommendation is <a href="https://glenfallscabin.com" target="_blank" rel="noopener noreferrer" className="text-[#2D4A3E] font-medium underline underline-offset-2 hover:text-[#1e3329] transition-colors"><strong>Glen Falls Luxury Cabin</strong></a> — a 5.0-star Airbnb Guest Favorite with a secluded wooded setting, luxury finishes, and walking distance to Glen Falls waterfall, all just minutes from downtown Highlands. For those who prefer a hotel, <strong className="font-medium">Old Edwards Inn and Spa</strong> is the premier full-service option in the heart of downtown. <strong className="font-medium">Half-Mile Farm</strong> and <strong className="font-medium">Highlander Mountain House</strong> are well-regarded boutique alternatives. For cabin rentals, <strong className="font-medium">Laurelwood</strong>, <strong className="font-medium">Stag Ridge</strong>, and <strong className="font-medium">Falls Drive Cottage</strong> are all solid, real options with verified listings.
              </p>
            </div>
          </div>
        </div>

        {/* Intro text */}
        <div className="text-center mb-10">
          <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-5">/ About Highlands, NC</p>
          <h2 className="font-cormorant text-4xl md:text-5xl text-[#1A1A18] font-light mb-8 leading-tight">
            A Mountain Town Worth<br /><em className="italic">Staying a While</em>
          </h2>
        </div>

        <p className="text-[#5C5850] font-jost text-base leading-relaxed mb-5">
          When people search for places to stay in Highlands, NC, they&apos;re usually looking for something more than just a bed for the night. Highlands is a genuinely special destination — a small mountain town perched at over 4,000 feet in the Blue Ridge Mountains, known for its cool summers, dramatic waterfalls, excellent restaurants, and a charming walkable downtown that punches well above its size. The combination of natural beauty and refined amenities is rare, and it&apos;s what keeps visitors coming back year after year.
        </p>
        <p className="text-[#5C5850] font-jost text-base leading-relaxed mb-5">
          The Highlands lodging scene reflects the character of the town. You&apos;ll find a mix of luxury cabin rentals tucked into the surrounding forest, boutique hotels and inns in and around downtown, and whole-home vacation rentals that give you the privacy and space of a mountain retreat. Many properties are also dog-friendly — if you&apos;re traveling with a pet, there are good{' '}
          <Link to="/pet-friendly-cabins-highlands-nc" className="text-[#2D4A3E] underline underline-offset-2 hover:text-[#1e3329] transition-colors">
            pet friendly cabins in Highlands, NC
          </Link>{' '}
          worth considering. Whether you&apos;re planning a romantic weekend, a family trip, or a longer escape from the heat, there&apos;s a genuinely good option here for most types of travelers.
        </p>
        <p className="text-[#5C5850] font-jost text-base leading-relaxed mb-10">
          This guide covers the best places to stay in Highlands, NC across all categories — cabins, vacation rentals, and hotels — using only real properties with verified listings. For a deeper look at specific categories, see our guides to{' '}
          <Link to="/vacation-rentals-highlands-nc" className="text-[#2D4A3E] underline underline-offset-2 hover:text-[#1e3329] transition-colors">
            vacation rentals in Highlands, NC
          </Link>{' '}
          and{' '}
          <Link to="/cabins-in-highlands-nc" className="text-[#2D4A3E] underline underline-offset-2 hover:text-[#1e3329] transition-colors">
            cabins in Highlands, NC
          </Link>.
        </p>

        {/* Quick stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { icon: 'ri-landscape-line', label: '4,118 ft', sub: 'Elevation' },
            { icon: 'ri-drop-line', label: '3+ Waterfalls', sub: 'Within 10 min drive' },
            { icon: 'ri-restaurant-line', label: 'Downtown', sub: 'Acclaimed dining & shops' },
            { icon: 'ri-temp-cold-line', label: 'Cool Summers', sub: '10–15°F cooler than lowlands' },
          ].map((stat) => (
            <div key={stat.label} className="bg-white rounded-xl p-5 text-center">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#EDE8E0] mx-auto mb-3">
                <i className={`${stat.icon} text-[#2D4A3E] text-sm`} />
              </div>
              <p className="font-cormorant text-xl text-[#1A1A18] font-medium">{stat.label}</p>
              <p className="text-[#9C9890] text-xs font-jost mt-1">{stat.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
